import { initStore }    from '../src/store';
import withRematch      from '../src/utils/withRematch';
import Layout           from '../src/containers/MineLayout';
import Job              from '../src/containers/Job';

const JobPage = (props) => {
    return (
        <Layout {...props}>
            <Job lang={props.lang} />
        </Layout>
    );
};

JobPage.getInitialProps = async function(ctx) {
    const { pathname, req, store } = ctx;

    let token = req ? req.cookies.token : null;

    await store.dispatch.user.getUserInfoFull({token});

    let curLang = req && req.language ? req.language.split('-')[0] : 'ru';

    return {
        headerClass: '',
        curLang,
        pathname,
        title: 'MOVER: Карьера и Вакансии',
        description: 'MOVER постоянно ищет в команду талантливых людей, которые беспрерывно находятся в поиске лучших решений в работе, людей с горящими глазами, желающих перевернуть мир и внести значимый вклад в индустрию. Присоединяйтесь к MOVER и мы вместе перевезем мир к лучшему!'
    }
};

const mapState = state => ({
    lang: state.lang,
    userInfo: state.user,
    activeOrder: state.orders.activeOrder
});

const mapDispatch = ({ orders: { acceptedOrder, declinedOrder }, user: { getUserInfoFull }, calculator: { searchStop, searchStart, update }, ws: { connect }}) => ({
    getUserInfoFull     :    () => getUserInfoFull(),
    calculatorUpdate:   (data) => update(data),
    wsConnect:          () => { connect() },
    searchStop:         (data) => searchStop(data),
    searchStart:        (data) => searchStart(data),
    acceptedOrder:      (orderId) => acceptedOrder(orderId),
    declinedOrder:      (orderId) => declinedOrder(orderId),
});

export default withRematch(initStore, mapState, mapDispatch)(JobPage);
